import { render, staticRenderFns } from "./StudentsWithBooks.vue?vue&type=template&id=d16e1a2e&scoped=true"
import script from "./StudentsWithBooks.vue?vue&type=script&lang=js"
export * from "./StudentsWithBooks.vue?vue&type=script&lang=js"
import style0 from "./StudentsWithBooks.vue?vue&type=style&index=0&id=d16e1a2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16e1a2e",
  null
  
)

export default component.exports